import React from 'react';

import { capitalize } from 'lodash';

import { ia } from 'lib/helpers/utility';

import Actions from 'components/practice/charts/Overview/widgets/components/Actions';
import { MEDICATION_STATUS } from 'components/practice/charts/Overview/widgets/lib/medicationsCols';
import Dot from 'components/shared/Dot/Dot';
import Icon from 'components/shared/Icon/Icon';
import Status from 'components/shared/Status/Status';

const disableRow = (params) => {
  const isOwner = params?.data?.patient_id === params?.data?.created_by;

  return !isOwner ? { 'pointer-events': 'none', opacity: '0.4' } : {};
};

export default (props, formatDate) => [
  {
    field: 'medication',
    headerName: 'Medication',
    headerCheckboxSelection: props?.showCheckboxes,
    checkboxSelection: props?.showCheckboxes,
    flex: 2,
    cellRenderer: (params) => {
      if (params.node.group || !params?.data) {
        return null;
      }

      const isMedicationActive = params?.data?.status === MEDICATION_STATUS.ACTIVE;
      const isPatient = params?.data?.patient_id === params?.data?.created_by;

      return (
        <div className="flex h-full w-full items-center gap-2">
          <Icon
            icon="document-preview-mono"
            shade={600}
            color="neutral"
            onClick={() => props.setShowMedicationModal({ open: true, data: params?.data })}
          />
          <Dot size="md" color={isMedicationActive ? 'success' : 'danger'} />

          <span className="truncate text-sm font-400 text-neutral-900">
            {params?.data?.medication}
          </span>

          {isPatient && <Icon icon="patient-response-mono" shade={600} />}
        </div>
      );
    }
  },
  {
    field: 'status',
    headerName: 'Status',
    cellRenderer: (params) => {
      if (params.node.group || !params?.data) return null;
      const status = params?.data?.status;
      return <Status status={status} />;
    }
  },
  {
    field: 'practice.name',
    headerName: 'Practice',
    valueFormatter: ({ value }) => (!!value ? value : 'N/A')
  },
  {
    field: 'dose',
    headerName: 'Dose',
    cellRenderer: (params) => {
      if (params.node.group || !params?.data) {
        return null;
      }
      const content = `${params?.data?.strength ?? ''}${params?.data?.unit ? `(${params?.data?.unit})` : ''}`;
      return content ? <span>{content}</span> : 'N/A';
    }
  },
  {
    field: 'product_ndc',
    headerName: 'NDC Code',
    valueFormatter: ({ value }) => (!!value ? value : 'N/A')
  },
  {
    field: 'prescriber.label',
    headerName: 'Prescriber',
    valueFormatter: ({ value }) => (!!value ? capitalize(value) : 'N/A')
  },
  {
    field: 'start_date',
    headerName: 'Start date',
    valueFormatter: ({ value }) => (value ? formatDate(value, props?.practice?.timezone) : 'N/A')
  },
  {
    field: 'end_date',
    headerName: 'End date',
    valueFormatter: ({ value }) => (value ? formatDate(value, props?.practice?.timezone) : 'N/A')
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: (params) => <Actions data={params?.data} customProps={props} />,
    maxWidth: 100,
    pinned: 'right',
    cellStyle: (params) => disableRow(params, props.userPermissions)
  }
];

export const disableIfNotOwner = ({ patientId, data }) => {
  return patientId !== data?.created_by;
};
export const getPrefilledPatientPractice = ({ data = [], formik = {} }) => {
  if (!ia(data)) {
    return [];
  }

  if (data?.length === 1 && !formik?.values?.practice_id) {
    const practice = data[0]?.practice;
    const practiceOption = { value: practice?.id, label: practice?.name };
    formik?.setFieldValue('practice_id', practiceOption?.value);

    return practiceOption;
  }
  if (data?.length > 1 || formik?.values?.practice_id) {
    const selectedPractice = data.find(
      (item) => item?.practice?.id === formik?.values?.practice_id
    )?.practice;

    return selectedPractice
      ? { value: formik?.values?.practice_id, label: selectedPractice?.name }
      : null;
  }

  return null;
};

export const getPatientPracticeOptions = (options) => {
  return options?.map((item) => ({ value: item?.practice?.id, label: item?.practice?.name }));
};
